const ServiceSubType = {

    // FIELDS
    "type": "Visitor Type",
    "name": "Visitor Sub Type Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "serviceSubType": "Visitor Sub Type",

    // ERROR
    "error_type": "Select Visitor Type",
    "error_name": "Enter Visitor Sub Type Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_type": 'VISITOR TYPE',
    "table_name": 'VISITOR SUB TYPE NAME',
    "table_status": "STATUS",

}

export default ServiceSubType;